export default "__VITE_ASSET__BbV4hphz__"